import { useEffect, useState } from 'react';
import { useRMSelector } from 'redux/hooks';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';

const getDuplicateScheduleEntries = (schedules) => {
  const duplicateRecords = [];
  return schedules.filter((item, index) =>
    schedules.some((i, ind) => {
      if (i.days == item.days && i.hours == item.hours && i.entryId != item.entryId) {
        const alreadyExist = duplicateRecords.find(
          (item) => item.days == i.days && item.hours == i.hours,
        );
        if (!alreadyExist) {
          duplicateRecords.push(i);
          return i;
        }
      }
    }),
  );
};
const useImagingSchedulingValidation = () => {
  const exp = useRMSelector(selectExp);
  const [duplicateRows, setDuplicateRows] = useState([]);
  useEffect(() => {
    const selectedImagingSchedule = exp?.imagingSchedule?.imagingSchedules.find(
      (item) => item.id === exp?.imagingSchedule?.selectedImagingScheduleId,
    );
    if (selectedImagingSchedule?.name === 'Custom') {
      const imagingScheduleEntries = exp.imagingSchedule?.imagingScheduleEntries.filter(
        (item) => item.id === selectedImagingSchedule.id,
      );
      setDuplicateRows(getDuplicateScheduleEntries(imagingScheduleEntries));
    } else {
      setDuplicateRows([]);
    }
  }, [exp?.imagingSchedule?.imagingScheduleEntries]);
  return duplicateRows;
};

export default useImagingSchedulingValidation;
